/** Valid Thai mobile format: 09 followed by 8 digits (separators are ignored). */
const PHONE_RE = /^09\d{8}$/;

class ContactPhoneValidation extends HTMLElement {
  /** @type {HTMLInputElement | null} */
  #input = null;

  /** @type {HTMLElement | null} */
  #error = null;

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    const input = this.querySelector('input[type="tel"]');
    const error = this.querySelector('.contact-us__phone-error');
    if (!(input instanceof HTMLInputElement)) return;

    this.#input = input;
    this.#error = error instanceof HTMLElement ? error : null;

    // Validate from the first keystroke (and on blur), so the error appears as the user types.
    input.addEventListener('input', () => this.#validate(), { signal });
    input.addEventListener('blur', () => this.#validate(), { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #validate() {
    if (!this.#input) return;

    const digits = this.#input.value.replace(/\D/g, '');
    // Empty is left to the native `required` validation on submit; only flag a
    // non-empty, badly-formatted number.
    const invalid = digits.length > 0 && !PHONE_RE.test(digits);

    this.toggleAttribute('data-invalid', invalid);
    this.#input.setAttribute('aria-invalid', invalid ? 'true' : 'false');
    if (this.#error) this.#error.hidden = !invalid;
  }
}

if (!customElements.get('contact-phone-validation')) {
  customElements.define('contact-phone-validation', ContactPhoneValidation);
}
